import useHydrateReportState from './useHydrateReportState';

/**
 * Rehydrates the report store from IndexedDB on mount and marks hydration complete once the restored state stops changing.
 *
 * @returns An empty div rendered purely to host the hydration effects.
 */
const InitFromIndexDB = () => {
  useHydrateReportState();
  return <div />;
};

export default InitFromIndexDB;
